import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/settings/integrations')({
	component: () => <Outlet />,
	staticData: {
		crumb: ({ context: { L } }) => L.Settings.Integrations.Title()
	}
})
